<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <div
                    class="alert alert-danger"
                >O tamanho das imagens pode impactar diretamente na performance e tempo de carregamento do aplicativo.</div>
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-menu"></i> Categoria
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.codigo.$error }"
                                >
                                    <label>Código*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.codigo"
                                    />
                                </div>

                                <div class="col-md-3 align-self-center">
                                    <label>Destaque</label>
                                    <br />
                                    <input-toggle v-model="model.destaque" :value="model.destaque"></input-toggle>
                                </div>
                            </div>
                            <div class="form-group row">
                              <div class="col-md-4">
                                <label>Idioma</label>
                                <Select2
                                    placeholder="Selecione"
                                    v-model="model.idioma"
                                    :options="tiposIdioma"
                                    opt-id="idioma"
                                >
                                    <option value selected>Selecione</option>
                                </Select2>
                              </div>
                            </div>
                            <div class="alert alert-warning">
                                <strong>Atenção!</strong>
                                O tamanho máximo e indicado para a
                                <strong>Imagem</strong> é de
                                <strong>300kb</strong>.
                            </div>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <file-image
                                        v-model="imagem"
                                        :label="'Imagem'"
                                        :arquivo="model.arquivoImagem"
                                    ></file-image>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-12">
                                    <file-image
                                        v-model="icone"
                                        :label="'Icone'"
                                        :arquivo="model.arquivoIcone"
                                    ></file-image>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{ name: 'list-category' }"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import Select from "../../components/Input/Select";
import FileImage from "../../components/Input/FileImage";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
import Select2 from '../../components/Input/Select2';
export default {
    components: {
        FileImage, Select2
    },
    data() {
        return {
            model: {
                id: null,
                nome: "",
                titulo: "",
                destaque: 0,
                codigo: "",
                arquivo: null,
                imagem: null,
                idioma: ''
            },
            tiposIdioma: Collections.idiomas,
            imagem: null,
            icone: null
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                nome: {
                    required,
                    minLength: minLength(2)
                },
                codigo: {
                    required,
                    minLength: minLength(2)
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
                const formData = new FormData();
                formData.append("data", JSON.stringify(vm.model));
                formData.append("imagem", vm.imagem);
                formData.append("icone", vm.icone);

                let ret = null;

                if (vm.model.id) {
                    ret = await facade.updateCategory(formData, vm.model.id);
                    this.$router.push({ name: "list-category" });
                } else {
                    ret = await facade.createCategory(formData);
                    vm.model.id = ret.data.data.id;
                    this.$router.push({
                        name: "list-category",
                        params: { id: vm.model.id }
                    });
                }

                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(model) {
            let vm = this;

            if (model !== undefined && model !== null) {
                vm.model = model;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let category = null;

        if (to.params.id) {
            category = (await facade.getCategory(to.params.id)).data.data;
        }

        next(vm => vm.setData(category));
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?db4052aa